import { api } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import { RootState } from '@/@types/member';

interface DocumentState {
  documents: any[];
}

const DOCUMENT_STATE: Module<DocumentState, RootState> = {
  state: {
    documents: [],
  },
  actions: {
    getDocuments(context): Promise<AxiosResponse> {
      return api.get('myDocuments').then((documents) => {
        context.commit('setDocuments', documents.data.result);
      });
    },
  },
  mutations: {
    setDocuments(state: DocumentState, documents: any[]) {
      state.documents = documents;
    },
  },
  getters: {
    getDocuments(state): any[] {
      return state.documents;
    },
    unassociatedDocuments(state): any[] {
      return state.documents.filter((document) => {
        return document.TransactionID === null;
      });
    },
    associatedDocuments(state): any[] {
      return state.documents.filter((document) => {
        return document.TransactionID !== null;
      });
    },
    getDocumentByID: (state) => (id): any => {
      return state.documents.find((document) => {
        return document.DocumentID === parseInt(id, 10);
      });
    },
  },
};

export default DOCUMENT_STATE;
